export enum Apps {
	Launcher = 'launcher',
	Camera = 'camera',
	Message = 'message',
	Ads = 'ads',
	JobElectrician = 'job_electrician',
	MyBusiness = 'my_business',
	Auction = 'auction',
	TruckJob = 'truck_job',
}
